import { TESTS_SET, TEST_ADDED, TEST_DELETED, TEST_EDITED } from 'src/app/redux/redux-types';
import { reduxTestTypes } from 'src/types';

export const testDefaultState: reduxTestTypes.StateType = {
  testList: [],
};

export const testReducer = (state = testDefaultState, action: reduxTestTypes.ActionType): reduxTestTypes.StateType => {
  switch (action.type) {
    case TESTS_SET:
      return {
        ...state,
        testList: action.payload,
      };
    case TEST_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.testList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        testList: [action.payload, ...state.testList],
      };
    case TEST_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.testList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        testList: [...state.testList.slice(0, updateIndex), action.payload, ...state.testList.slice(updateIndex + 1)],
      };
    case TEST_DELETED:
      return {
        ...state,
        testList: state.testList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
